import React, { useState, useEffect } from 'react';

function LapHk() {
  const [LapPasangData, setLapPasangData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [end_date, setEndDate] = useState(formatDate(addDays(new Date(), 0)));
  const [filters, setFilters] = useState({});
  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });
  const schema = localStorage.getItem('schema');

  function addDays(date, days) {
    const result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
  }

  function formatDate(date) {
    return date.toISOString().split('T')[0];
  }

  const formatNumber = (value) =>
    isNaN(value) ? value : new Intl.NumberFormat('id-ID').format(Number(value));

  const numericKeys = [
    'HK_BON',
    'HK_CUSTOMER',
    'HK_AWAL',
    'HK_LAKA',
    'HK_PERLENGKAPAN',
    'HK_TOTAL',
    'TAB_SALDO',
    'SISA_KURANG',
    'KELEBIHAN',
  ];

  const columns = [
    'SOPIR',
    'JNS_KENDARAAN',
    'AREA',
    'HK_BON',
    'HK_CUSTOMER',
    'HK_AWAL',
    'HK_LAKA',
    'HK_PERLENGKAPAN',
    'HK_TOTAL',
    'TAB_SALDO',
    'SISA_KURANG',
    'KELEBIHAN',
  ];

  const fetchLapPasangData = async () => {
    try {
      const url = `${process.env.REACT_APP_API_BASE_URL}/laporan.php?caller=lap_hk&schema=${schema}&end_date=${end_date}`;
      const response = await fetch(url);
      const data = await response.json();
      if (Array.isArray(data)) {
        setLapPasangData(data);
        setFilteredData(data);
      } else {
        throw new Error('Data tidak valid');
      }
    } catch (error) {
      alert('Gagal memuat data');
    }
  };

  useEffect(() => {
    fetchLapPasangData();
  }, [end_date]);

  useEffect(() => {
    let filtered = LapPasangData.filter((item) =>
      Object.keys(filters).every((key) =>
        filters[key] === '' || String(item[key] ?? '').toLowerCase().includes(filters[key].toLowerCase())
      )
    );
    setFilteredData(filtered);
  }, [filters, LapPasangData]);

  const handleSort = (key) => {
    const direction = sortConfig.key === key && sortConfig.direction === 'asc' ? 'desc' : 'asc';
    setSortConfig({ key, direction });

    const sorted = [...filteredData].sort((a, b) => {
      if (a[key] < b[key]) return direction === 'asc' ? -1 : 1;
      if (a[key] > b[key]) return direction === 'asc' ? 1 : -1;
      return 0;
    });

    setFilteredData(sorted);
  };

  const getSortIcon = (key) =>
    sortConfig.key === key ? (sortConfig.direction === 'asc' ? '▲' : '▼') : '';

  return (
    <div>
      <div className="section-header">
        <h2>Laporan Hutang Karyawan</h2>
        <div className="responsive-filter">
          <label>Periode s.d: </label>
          <input
            type="date"
            value={end_date}
            onChange={(e) => setEndDate(e.target.value)}
          />
          <button onClick={fetchLapPasangData}>Refresh</button>
        </div>
      </div>

      <div style={{ overflowX: 'auto', background: '#fff', borderRadius: '0 0 10px 10px', boxShadow: '0 1px 3px rgba(0,0,0,0.08)' }}>
        <table className="responsive-table">
          <thead>
            <tr>
              {columns.map((col) => (
                <th key={col} onClick={() => handleSort(col)} style={{ textAlign: 'center' }}>
                  {col.replace('HK_', '').replace('_', ' ')} {getSortIcon(col)}
                </th>
              ))}
            </tr>
            <tr>
              {columns.map((col) => (
                <th key={`filter-${col}`} style={{ padding: '4px' }}>
                  <input
                    type="text"
                    placeholder="Filter..."
                    style={{ width: '90%', padding: '4px', fontSize: '12px' }}
                    onChange={(e) => setFilters({ ...filters, [col]: e.target.value })}
                  />
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {filteredData.length > 0 ? (
              filteredData.map((item, idx) => (
                <tr key={idx}>
                  {columns.map((key) => (
                    <td key={key} style={{ textAlign: numericKeys.includes(key) ? 'right' : 'left' }}>
                      {numericKeys.includes(key) ? formatNumber(item[key]) : item[key]}
                    </td>
                  ))}
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={columns.length} style={{ textAlign: 'center', padding: '20px', color: '#999' }}>
                  Tidak ada data
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default LapHk;
